import { render, staticRenderFns } from "./mediaDialog.vue?vue&type=template&id=46156176&scoped=true"
import script from "./mediaDialog.vue?vue&type=script&lang=js"
export * from "./mediaDialog.vue?vue&type=script&lang=js"
import style0 from "./mediaDialog.vue?vue&type=style&index=0&id=46156176&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "46156176",
  null
  
)

export default component.exports